/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Key_ManagerInputs */



/**
* | output |
* | --- |
* | "API Key Manager" |
*
* @param {Api_Key_ManagerInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const api_key_manager = /** @type {((inputs?: Api_Key_ManagerInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Key_ManagerInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gestionnaire de clés API")
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Schlüsselmanager")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestore chiavi API")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Менеджер ключей API")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administrador de claves API")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("API密钥管理器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("APIキーマネージャー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एपीआई कुंजी प्रबंधक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerenciador de chaves de API")
	return /** @type {LocalizedString} */ ("API Key Manager")
});